import type { FC } from "react";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import LinearProgress from "@mui/material/LinearProgress";

interface ToolbarProgressProps {
  loading: boolean;
}

/**
 * Полоса прогресса по нижней кромке тулбара выбранных строк.
 *
 * Зачем она нужна: массовое действие выбирается в меню, меню тут же
 * закрывается, и `disabled` на его пунктах пользователю уже не виден. До
 * этого компонента клик по «Опубликовать» не давал вообще никакого отклика,
 * пока не приедет ответ сервера.
 *
 * Тот же приём, что в шапке диалогов (`DialogHeader`): `Fade` вокруг
 * `LinearProgress`, чтобы полоса не мигала на быстрых ответах. Родительский
 * `Toolbar` обязан иметь `position: relative`, иначе полоса уедет к
 * ближайшему позиционированному предку.
 */
export const ToolbarProgress: FC<ToolbarProgressProps> = ({ loading }) => (
  <Box position="absolute" left={0} right={0} bottom={0}>
    <Fade in={loading}>
      <LinearProgress sx={{ height: 2 }} />
    </Fade>
  </Box>
);
